import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/public/img/qlife-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/Breadcrumb.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_styles/footer.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_styles/header.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_styles/layout.scss");
